import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GoogleSignInButton } from '../components/GoogleSignInButton';

export function LoginPage() {
  const { user, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  if (loading) {
    return (
      <div className="min-h-full flex items-center justify-center t-muted">
        Chargement...
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;

  return (
    <div className="min-h-full relative flex items-center justify-center p-6 overflow-hidden">
      {/* Aurora animée */}
      <div className="aurora-blob h-[420px] w-[420px] bg-cyan-500 -top-24 -left-24" aria-hidden="true" />
      <div
        className="aurora-blob h-[380px] w-[380px] bg-violet-600 -bottom-20 -right-16"
        style={{ animationDelay: '-7s' }}
        aria-hidden="true"
      />
      <div
        className="aurora-blob h-[300px] w-[300px] bg-teal-500 top-1/3 left-2/3"
        style={{ animationDelay: '-3.5s', opacity: 0.22 }}
        aria-hidden="true"
      />

      <div className="relative w-full max-w-md">
        <div className="panel p-8 text-center bd shadow-[0_20px_60px_rgba(2,6,23,0.6)]">
          <img src="/favicon.png" alt="ZCE" className="mx-auto mb-5 h-14 w-auto" />
          <h1 className="page-title mb-1">ZCE Backoffice</h1>
          <p className="text-[13px] t-muted mb-8">Suivi et maintenance de la flotte IoT</p>
          <div className="flex justify-center">
            <GoogleSignInButton onError={setError} />
          </div>
          {error && <p className="text-red-400 text-sm mt-4">{error}</p>}
          <p className="text-xs t-faint mt-8">Acces reserve aux comptes @zce-group.com</p>
        </div>
      </div>
    </div>
  );
}
